import { AlertResponse, Media, MediasResponse } from "../types/media";
import { TaskLinks } from "../types/taskLink";
import { MediasViewListDesktop } from "./MediasViewListDesktop";
import { MediasViewArticleListDesktop } from "./MediasViewArticleListDesktop";
import { ArticleWithMediaCount } from "../types/article";
import { useTranslation } from "@coworker/locales";
import styled from "styled-components";

const SectionHeaderText = styled("div")`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  padding: 16px 0px;
`;

const ArticleSectionHeaderText = styled(SectionHeaderText)`
  padding: 32px 0px 16px 0px;
`;

interface MediasViewSearchListDesktopProps {
  mediasResponse: MediasResponse | undefined;
  alerts: AlertResponse[] | undefined;
  taskCountsByMediaId: Map<string, number>;
  taskLinks: TaskLinks;
  onSaveMedia: (media: Media) => void;
  storeId: string;
  articles: ArticleWithMediaCount[] | undefined;
}

export function MediasViewSearchListDesktop({
  mediasResponse,
  alerts,
  taskCountsByMediaId,
  taskLinks,
  onSaveMedia,
  storeId,
  articles,
}: MediasViewSearchListDesktopProps) {
  const { t } = useTranslation();

  return (
    <>
      <MediasViewListDesktop
        mediasResponse={mediasResponse}
        alerts={alerts}
        taskCountsByMediaId={taskCountsByMediaId}
        onSaveMedia={onSaveMedia}
      />
      {!!articles && articles.length > 0 && (
        <ArticleSectionHeaderText>
          {t("countArticlesString", { count: articles?.length ?? 0 })}
        </ArticleSectionHeaderText>
      )}
      <MediasViewArticleListDesktop
        articles={articles}
        taskLinks={taskLinks}
        storeId={storeId}
      />
    </>
  );
}
